module.exports = __webpack_public_path__ + "52838241b87ab4d46fd6a32f54da8dd8.svg";